import './styles.module.css';

import { Link } from 'gatsby';
import React from 'react';

import { ReactComponent as NavMenuIcon } from '../../assets/nav-menu.svg';
import { ReactComponent as CloseIcon } from '../../assets/x.svg';
import { Breadcrumb, BreadcrumbProps } from '../../components/breadcrumb';
import { Button } from '../../components/button';
import { useAuth } from '../../contexts/auth';
import { isV2OrLater } from '../../util/deployment-version';
import {
	content,
	headerImage,
	input,
	inputContainer,
	loginNavLink as loginNavLinkStyle,
	searchBox as searchBoxStyle,
	selected,
} from './styles.module.css';

export interface PageHeaderNavigationItem {
	title?: string | null;
	slug?: string | null;
}

export interface PageHeaderProps {
	logoImageSource?: string | null;
	logoAltText?: string | null;
	logoLinkHref?: string | null;
	navItems?: ReadonlyArray<PageHeaderNavigationItem | null> | null;
	breadcrumb?: BreadcrumbProps;
	searchInput?: boolean;
}

export const PageHeader = ({
	logoImageSource,
	logoLinkHref,
	logoAltText,
	navItems,
	breadcrumb,
	searchInput = true,
}: PageHeaderProps): JSX.Element => {
	const { session } = useAuth();

	return (
		<header>
			<input type="checkbox" id="nav-toggle" />
			<label htmlFor="nav-toggle">
				<NavMenuIcon data-closed />
				<CloseIcon data-open />
			</label>
			<div className={content}>
				<div id="nav-header">
					{!!logoImageSource && (
						<Link to={logoLinkHref ?? '/'}>
							<img src={logoImageSource} alt={logoAltText ?? undefined} className={headerImage} />
						</Link>
					)}

					<nav>
						{Array.isArray(navItems) && (
							<ul>
								{isV2OrLater() && (
									<li className={searchBoxStyle}>
										<form action="/search/" method="GET">
											<input
												name="query"
												type="search"
												className={input}
												disabled={!searchInput}
												aria-label="Search"
											/>
										</form>
									</li>
								)}
								{navItems.map(
									({ title, slug }, index) =>
										!!title &&
										!!slug && (
											<li key={`${index}-${slug}`}>
												<Link to={slug ?? undefined} activeClassName={selected} partiallyActive>
													{title}
												</Link>
											</li>
										)
								)}
								{isV2OrLater() && (
									<li className={loginNavLinkStyle}>
										<Button to="/dashboard"> {session ? 'Dashboard' : 'Log In'}</Button>
									</li>
								)}
							</ul>
						)}
					</nav>
				</div>
				{!!breadcrumb && <Breadcrumb {...breadcrumb} />}
			</div>
		</header>
	);
};
